import { FullPageLoader } from './FullPageState'

export function SuspenseFallback() {
  return <FullPageLoader />
}
